import { render, staticRenderFns } from "./WarningView.vue?vue&type=template&id=4062dd54&scoped=true"
import script from "./WarningView.vue?vue&type=script&lang=js"
export * from "./WarningView.vue?vue&type=script&lang=js"
import style0 from "./WarningView.vue?vue&type=style&index=0&id=4062dd54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4062dd54",
  null
  
)

export default component.exports